import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {TicketDashboardComponent} from './ticket.dashboard/ticket.dashboard.component'

const TicketsRouting: Routes = [
    {
        path: 'support-tickets', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: TicketDashboardComponent },
            { path: 'support-tickets', component: TicketDashboardComponent },

            // handle all other routes
            { path: '**', component: TicketDashboardComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(TicketsRouting)],
    exports: [RouterModule]
})
export class TicketsRoutingModule { }
